<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Events from './events'

import axios from 'axios'

export default {
	page: {
		title: 'All Office 365 Events',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Events },
	data() {
		return {
			title: 'Todos los eventos de Office 365',
			category: 'List',
			items: [
				{
					text: 'Inicio',
					href: '/',
				},
				{
					text: 'Todos los eventos',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<!-- <Events :url="'/office365/events/list?limit=100'"/> -->
						<Events :url="'/office365/events/list?'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
